module.exports = __webpack_public_path__ + "static/img/6.e8d7271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha/6.png
// module id = eYkZ
// module chunks = 1